// /**
//  * Created by Bazu-05 on 28.01.2020.
//  */

import {
    search,
    fetchLayers,
    fetchLocations,
    updateLocation,
    fetchAddresses,
    fetchDrivingZone
} from "@/api/api.js"
import {createGeoJSONCircle} from "@/helpers/createGeoJSONCircle.js"
import {createPolygonLayers, createPolygonLayer, createCircleLayer, metersToPixelsAtMaxZoom, findCircleById} from "@/helpers/map.js"
const GYM_ID = 1;
import {MAP_SERVICES_SOURCE_ID, MAP_ADDRESS_SOURCE_ID, MAP_DRAWING_ZONE} from '@/data/variables'
import mapboxgl from 'mapbox-gl'

export const map = {
    state: {
        map: {},
        earthquakes: {
            "type": "FeatureCollection",
            "features": []
        },
        suggestions: [],
        Addresses: {
            "type": "FeatureCollection",
            "features": []
        },
        drivingZone: {
            type: "FeatureCollection",
            features: [],
            currentId: 0
        },
        CURRENT_SERVICES: [],
        DRAW_MARKERS: false,
        SEARCH_MARKER: null
    },
    mutations: {
        SET_CIRCLE_LAYERS(state, payload) {
            let circles = [];
            if(payload.length > 0) {
                circles = createPolygonLayers(payload);
            }
            state.earthquakes.features = circles
        },
        RESET_CIRCLE_LAYERS(state) {
          state.earthquakes.features = []
        },
        MANAGE_PROTECTION_AREA_RADIUS(state, payload) {
            const {id, protection_area_radius_enabled} = payload;
            const earthquakes = state.earthquakes.features;
            const currentIndex = findCircleById(earthquakes, id)
            earthquakes[currentIndex].properties.protection_area_radius_enabled = protection_area_radius_enabled;
        },
        SET_DRIVE_TIME(state, payload) {
            const {id, driving_time_zone_minutes} = payload;
            const earthquakes = state.earthquakes.features;
            const currentIndex = findCircleById(earthquakes, id)
            earthquakes[currentIndex].properties.driving_time_zone_minutes = driving_time_zone_minutes
        },
        SAVE_MAP(state, payload) {
            state.map = payload;
        },
        SAVE_SUGGESTIONS(state, payload) {
            state.suggestions = payload
        },
        SAVE_ADDRESSES(state, payload) {
            let pins = [];
            if(payload.length > 0) {
                pins = payload.map(item => {
                    return {
                        type: "Feature",
                        properties: {...item},
                        geometry: {
                            type: "Point",
                            coordinates: [item.lat, item.lng]
                        }
                    }
                })
            }
            state.Addresses.features = pins
        },
        SET_DRAW_MARKERS(state, payload) {
            state.DRAW_MARKERS = payload
        },
        REMOVE_ADDRESSES(state, payload) {
            state.Addresses.features = [...state.Addresses.features].filter(item => +item.properties.location_id !== +payload)
        },
        CREATE_DRIVING_ZONE(state, payload) {
            state.drivingZone = payload;
            state.map.getSource(MAP_DRAWING_ZONE).setData(state.drivingZone);
        },
        REMOVE_DRIVING_ZONE(state) {
            state.drivingZone.features = [];
            state.drivingZone.currentId = 0;
            state.map.getSource(MAP_DRAWING_ZONE).setData(state.drivingZone)
        },
        SET_CURRENT_SERVICES(state, payload) {
            state.CURRENT_SERVICES = payload;
        },
        ADD_SEARCH_MARKER(state, payload) {
            const {lat,lng} = payload;
            const map = state.map;
            const marker = new mapboxgl.Marker({
                color: "#2c64ff"
            })
            .setLngLat([lat, lng])
            marker.addTo(map)
            state.SEARCH_MARKER = marker;
        },
        REMOVE_SEARCH_MARKER(state) {
            const SEARCH_MARKER = state.SEARCH_MARKER;
            if(!SEARCH_MARKER) return;
            SEARCH_MARKER.remove();

        }
    },
    getters: {
        getEarthquakes: state => state.earthquakes,
        getAddresses: state => state.Addresses,
        getDrawMarkers: state => state.DRAW_MARKERS,
        getDrivingServiceById: state => state.drivingZone.currentId,
        getCurrentServices: state => state.CURRENT_SERVICES
        // getLayerColors: () => {
        //     let layers = JSON.parse(localStorage.getItem('layers')).data;
        //     let colors_hex = layers.map(layer => layer.color_hex)
        //     return colors_hex;
        // },
    },
    actions: {

        SAVE_MAP({commit}, map) {
            commit("SAVE_MAP", map)
        },
        FLY_MAP({state, commit}, points) {
            const map = state.map;
            commit('REMOVE_SEARCH_MARKER');
            commit('ADD_SEARCH_MARKER', points);
            let {lat, lng} = points;
                map.flyTo({
                    center: [
                        lat,
                        lng
                    ],
                    zoom: 9,
                    essential: true,
                    // speed: 0.66, // make the flying slow
                    curve: 2, // change the speed at which it zooms out
                });


        },
        UPDATE_MAP({state}) {
            const map = state.map,
                earthquakes = state.earthquakes;
            map.getSource(MAP_SERVICES_SOURCE_ID).setData(earthquakes)

        },
        CREATE_DRIVING_ZONE({commit}, payload) {
          commit('CREATE_DRIVING_ZONE', payload)
        },
        REMOVE_DRIVING_ZONE({commit}) {
            commit('REMOVE_DRIVING_ZONE')
        },

        UPDATE_ADDRESSES({state}) {
            const map = state.map,
                addresses = state.Addresses;
            map.getSource(MAP_ADDRESS_SOURCE_ID).setData(addresses)
        },

        SAVE_LOCATIONS({commit}, locations) {
            // commit('SET_POLYGON_LAYER', locations)
          commit('SET_CIRCLE_LAYERS', locations)
        },
        async search({commit}, code) {
            try {
                const response = await search(code);
                commit('SAVE_SUGGESTIONS', response.data.data.suggestions)
                return response;
            } catch (error) {
                // handle the error here
            }
        },
        async updateLocation({commit, dispatch}, {id, protection_area_radius_enabled, driving_time_zone_minutes, setRadius, update}) {
            commit('SET_DRAW_MARKERS', false)

            if(setRadius) {
                commit('MANAGE_PROTECTION_AREA_RADIUS', {id, protection_area_radius_enabled});
                // commit('SET_RADIUS', {id, protection_area_radius_km})
            } else {
                commit('SET_DRIVE_TIME', {id, driving_time_zone_minutes})
            }
            dispatch('UPDATE_MAP');
            if(update) {
                try {
                    const response = await updateLocation(id, {protection_area_radius_enabled, driving_time_zone_minutes});
                    return response;
                } catch (error) {
                    // handle the error here
                }
            }
        },
        async fetchLayers() {
            const servicesSelectList = JSON.parse(localStorage.getItem('servicesSelectList'))
            try {
                const response = await fetchLayers();
                if(response.status === 200) {
                    const services = response.data.data.layers;
                    let today = new Date();
                    today.setHours(today.getHours() + 1);
                    // today.setTime(today.getTime() + 1*60*1000) 1 min for a test;
                    localStorage.setItem('services', JSON.stringify({exp: today.getTime(), data: services}));
                    if(!servicesSelectList) {
                        const servicesId = services.map(layer => layer.id);
                        localStorage.setItem('servicesSelectList', JSON.stringify(servicesId));
                    }
                }

                return response;
            } catch (error) {
                // handle the error here
            }
        },

        async fetchLocations({commit, dispatch}, payload) {
            const servicesSelectedList = JSON.parse(localStorage.getItem('servicesSelectList'));
            const Circle = payload?.circle;
            let selectedServices;

            // set selected flags from storage
            if(servicesSelectedList) {
                selectedServices = servicesSelectedList;
            } else {
                 // first init select all
                const services = JSON.parse(localStorage.getItem('services')).data;
                selectedServices = services.map(item => item.id)
            }
            commit('SET_DRAW_MARKERS', true);
            // commit('RESET_CIRCLE_LAYERS');

            try {
                commit('SET_CURRENT_SERVICES', selectedServices)
                const response = await fetchLocations(selectedServices, Circle);
                const locations = response.data.data.locations;
                dispatch('SAVE_LOCATIONS', locations)
                dispatch('UPDATE_MAP');
                return response;
            } catch (error) {
                // handle the error here
            }
        },
        async fetchAddresses({commit, dispatch}, data) {
            let statuses;
            let selectedItems = JSON.parse(localStorage.getItem('legendsSelectList'));
            if(selectedItems) {
                statuses = selectedItems.filter(l => l !== GYM_ID)
            }
            data = {...data, statuses}
            try {
                const response = await fetchAddresses(data);
                commit('SAVE_ADDRESSES', response.data.data.addresses)
                dispatch('UPDATE_ADDRESSES')
                return response;
            } catch (error) {
                // handle the error here
            }
        },
        async fetchDrivingZone({dispatch}, data) {
            try {
                let {id, minutes} = data
                const response = await fetchDrivingZone(id, minutes);
                const features = response.data.data.features
                if(!features.code) {
                    dispatch('CREATE_DRIVING_ZONE', {...features, currentId: id});
                    return 'created'
                }
            }catch(e) {
                console.log(e, 'error here')
            }
        }
    }
}




